"use client";

import React, { Component, Fragment } from "react";
import Header from "../Header";
import WebNotif from "../../components/WebNotif";
import { withRouter } from "react-router-dom";

var obj = new WebNotif();

class EngineerSponsorForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedFile: null,
      isDragOver: false,
      reduxEpeForm: JSON.parse(localStorage.getItem("reduxEpeForm")) || {},
    };
  }

  componentDidMount() {
    const savedFormData = JSON.parse(localStorage.getItem("reduxEpeForm"));
    if (
      savedFormData &&
      savedFormData.form &&
      savedFormData.form.sponsorDocument
    ) {
      this.setState({
        uploadedFile: savedFormData.form.sponsorDocument,
      });
    }
  }

  handleFileUpload = (file) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ];
    const maxSize = 2 * 1024 * 1024; // 2MB

    if (!allowedTypes.includes(file.type)) {
      obj.createNotification(
        "error",
        "Please upload a PDF or image file (JPG, PNG, WebP)."
      );
      return;
    }

    if (file.size > maxSize) {
      obj.createNotification("error", "File size must be less than 2MB.");
      return;
    }

    this.setState({
      uploadedFile: file,
    });

    obj.createNotification("success", "File uploaded successfully!");
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      this.handleFileUpload(files[0]);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
  };

  handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.handleFileUpload(file);
    }
  };

  removeFile = () => {
    this.setState({ uploadedFile: null });
  };

  downloadSponsorForm = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/downloads/Sponsor Recommendation Format.pdf`;
    link.download = "Sponsor Recommendation Format.pdf";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    obj.createNotification("success", "Sponsor proforma downloaded");
  };

  getFileIcon = (fileType) => {
    if (fileType === "application/pdf") {
      return "fas fa-file-pdf text-danger";
    } else if (fileType.startsWith("image/")) {
      return "fas fa-file-image text-primary";
    }
    return "fas fa-file text-secondary";
  };

  formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
    );
  };

  fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!(file instanceof Blob)) {
        reject(new TypeError("Expected a File or Blob"));
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file); // convert Blob/File to base64
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  saveToLocalStorage = async () => {
    const { uploadedFile } = this.state;

    if (!uploadedFile) {
      obj.createNotification(
        "error",
        "Please upload the signed sponsor form before proceeding."
      );
      return;
    }
    try {
      // Allow only PDF or Images
      if (
        uploadedFile.type !== "application/pdf" &&
        !uploadedFile.type.startsWith("image/")
      ) {
        obj.createNotification("error", "Only PDF or Image files are allowed.");
        return;
      }

      // Convert to base64
      const base64File = await this.fileToBase64(uploadedFile);

      const updatedForm = {
        ...this.state.reduxEpeForm,
        form: {
          ...this.state.reduxEpeForm.form,
          sponsorDocument: base64File, // base64 string with correct mime type
        },
      };

      localStorage.setItem("reduxEpeForm", JSON.stringify(updatedForm));
      obj.createNotification("success", "Sponsor document saved successfully.");

      this.props.history.push("/engineer/application-preview");
    } catch (err) {
      console.error("File conversion failed:", err);
      obj.createNotification("error", "Failed to save sponsor document.");
    }
  };

  render() {
    const { uploadedFile, isDragOver } = this.state;

    return (
      <Fragment>
        <Header />
        <div className="container mt-4">
          <h3 className="text-center">Sponsor Details</h3>
          <h5 className="text-center mt-3 co_g20A84C font-weight-bold font-16 mb-4">
            Step 5: Add Sponsor Information
          </h5>

          <div className="container" style={styles.container}>
            <div className="row">
              <div className="col-12">
                <div className="alert alert-info mb-4">
                  <h6 className="alert-heading mb-3">
                    <i className="fas fa-info-circle mr-2"></i>
                    Sponsor Form Process
                  </h6>
                  <ol className="mb-0 pl-3">
                    <li>
                      Download the sponsor proforma using the button below
                    </li>
                    <li>Have your sponsor fill out and sign the form</li>
                    <li>Upload the completed and signed form</li>
                    <li>Proceed to application preview</li>
                  </ol>
                </div>

                <div className="card mb-4">
                  <div className="card-body text-center">
                    <h6 className="card-title mb-3">
                      Step 1: Download Sponsor Proforma
                    </h6>
                    <button
                      type="button"
                      className="btn admin_btn_default btn-lg  w-auto"
                      onClick={this.downloadSponsorForm}
                      // style={{ width: "auto" }}
                    >
                      <i className="fas fa-download mr-2"></i>
                      Download Sponsor Proforma
                    </button>
                    <p className="text-muted mt-2 mb-0">
                      Download the official sponsor form template
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title mb-3">
                      Step 2: Upload Signed Sponsor Form
                    </h6>

                    {!uploadedFile ? (
                      <div
                        className={`border-2 border-dashed rounded p-4 text-center ${
                          isDragOver
                            ? "border-primary bg-light"
                            : "border-secondary"
                        }`}
                        onDrop={this.handleDrop}
                        onDragOver={this.handleDragOver}
                        onDragLeave={this.handleDragLeave}
                        style={{ minHeight: "200px", cursor: "pointer" }}
                      >
                        <div className="d-flex flex-column align-items-center justify-content-center h-100">
                          <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                          <h6 className="mb-2">
                            Drag and drop your signed sponsor form here
                          </h6>
                          <p className="text-muted mb-3">or</p>
                          <label className="btn admin_btn_default btn-lg w-auto">
                            <i className="fas fa-folder-open mr-2"></i>
                            Browse Files
                            <input
                              type="file"
                              className="d-none"
                              accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp"
                              onChange={this.handleFileInputChange}
                            />
                          </label>
                          <small className="text-muted mt-2">
                            Accepted formats: PDF, JPG, PNG, GIF, BMP, WebP (Max
                            5MB)
                          </small>
                        </div>
                      </div>
                    ) : (
                      <div className="alert alert-success">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <i
                              className={`${this.getFileIcon(
                                uploadedFile.type
                              )} fa-2x mr-3`}
                            ></i>
                            <div>
                              <h6 className="mb-1">{uploadedFile.name}</h6>
                              <small className="text-muted">
                                {this.formatFileSize(uploadedFile.size)} •
                                Uploaded successfully
                              </small>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn admin_btn_default bold float-right text-capitalize"
                            onClick={this.removeFile}
                          >
                            <i className="fas fa-trash mr-1"></i>
                            Remove
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row col_margin mt-40 mb-40">
            <div
              className="d-flex justify-content-end mt-4 mb-4"
              style={{ width: "95%" }}
            >
              <button
                type="button"
                className={`btn bold float-right text-capitalize ${
                  uploadedFile ? "admin_btn_default" : "btn-secondary"
                }`}
                style={{ width: "200px" }}
                onClick={this.saveToLocalStorage}
                disabled={!uploadedFile}
              >
                Save and Preview
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
    marginBottom: "30px",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "5px",
    display: "block",
  },
  required: {
    color: "#06580e",
  },
};

export default withRouter(EngineerSponsorForm);
